import { render, staticRenderFns } from "./regist_up.vue?vue&type=template&id=5b44a588&scoped=true"
import script from "./regist_up.vue?vue&type=script&lang=js"
export * from "./regist_up.vue?vue&type=script&lang=js"
import style0 from "./regist_up.vue?vue&type=style&index=0&id=5b44a588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b44a588",
  null
  
)

export default component.exports